import type { ComponentProps } from 'react';
import { cn } from '../lib/cn.ts';
import type { Space } from '../lib/scale.ts';

export type GridColumns = 1 | 2 | 3 | 4 | 6 | 12;

const columnClasses: Record<GridColumns, string> = {
  1: 'grid-cols-1',
  2: 'grid-cols-1 sm:grid-cols-2',
  3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
  4: 'grid-cols-2 lg:grid-cols-4',
  6: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6',
  12: 'grid-cols-4 sm:grid-cols-6 lg:grid-cols-12',
};

const gaps: Record<Space, string> = {
  none: 'gap-0',
  xs: 'gap-1',
  sm: 'gap-2',
  md: 'gap-4',
  lg: 'gap-6',
  xl: 'gap-10',
};

export interface GridProps extends ComponentProps<'div'> {
  columns?: GridColumns;
  gap?: Space;
}

/**
 * Two-dimensional layout. `columns` is the count at the widest breakpoint and
 * the map above narrows it on small screens, so a mockup is responsive without
 * its author thinking about breakpoints — which is the part of a layout that
 * gets skipped and then discovered on a phone.
 */
export function Grid({ columns = 2, gap = 'md', className, ...props }: GridProps) {
  return <div className={cn('grid', columnClasses[columns], gaps[gap], className)} {...props} />;
}
